// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"34223":"commons","36209":"ui","72213":"sbanken","91336":"eiendom"}[chunkId] + "." + {"34223":"18c273f18b4130b1fe20","36209":"1ff1648d715a71062bd1","72213":"ecd7a5dbcd6984685f8c","91336":"045c467d3bafa7cd2d38"}[chunkId] + ".css";
};